import { FunctionComponent } from 'react';
import UniversitiesPage from './UniversitiesPage';

interface Props {}

const Universities: FunctionComponent<Props>  = () => {

    return (
        <UniversitiesPage title={'Universities'} />
    );
};

export default Universities;
